module.exports = __webpack_public_path__ + "media/applications/assets/images/size-info/leggings-03f1a4bf706490b6a70223eb7389acee.png";